import apiClient from './client';

export const prCampaignsAPI = {
  getAll: () => apiClient.get('/pr-campaigns'),
  getOne: (id) => apiClient.get(`/pr-campaigns/${id}`),
  create: (data) => apiClient.post('/pr-campaigns', data),
  update: (id, data) => apiClient.put(`/pr-campaigns/${id}`, data),
  delete: (id) => apiClient.delete(`/pr-campaigns/${id}`),
  poll: (id) => apiClient.post(`/pr-campaigns/${id}/poll`),
  addArticle: (id, data) => apiClient.post(`/pr-campaigns/${id}/articles`, data),
  dismissArticle: (id, articleId) => apiClient.patch(`/pr-campaigns/${id}/articles/${articleId}/dismiss`),
  restoreArticle: (id, articleId) => apiClient.patch(`/pr-campaigns/${id}/articles/${articleId}/restore`),
  updateSentiment: (id, articleId, sentiment) => apiClient.patch(`/pr-campaigns/${id}/articles/${articleId}/sentiment`, { sentiment }),
  fetchShareOfVoice: (id) => apiClient.post(`/pr-campaigns/${id}/share-of-voice`),
};
